<template>
    <v-form @submit.prevent="submitFile" ref="form">
        <v-container>
            <v-row>
                <v-col cols="12" md="12">
                    <v-file-input label="Choose CSV file to upload" variant="outlined" @change="fileChanged"
                        :disabled="submitDisabled" />
                    <v-btn type="submit" block append-icon="mdi-upload" :disabled="submitDisabled"
                        :loading="uploadInProgress">Submit</v-btn>
                </v-col>
            </v-row>
            <v-row v-if="message">
                <v-col cols="12" md="12">
                    <h4 style="padding-top: 30px; padding-bottom: 15px;"
                        :class="uploadSuccessful ? 'text-green' : 'text-red'">
                        {{ uploadSuccessful ? "Success!" : "Upload failed" }}
                    </h4>
                    <v-code>{{ message }}</v-code>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="12">
                    <v-btn v-if="doneVisible" prepend-icon="mdi-check-circle" @click="doneClicked">Done</v-btn>
                </v-col>
            </v-row>
        </v-container>
    </v-form>
</template>

<script setup lang="ts">
import { postFile } from "@/services/labview-api.service";
import { ref, computed } from "vue";
import { useAuth0 } from "@auth0/auth0-vue";

const form = ref<HTMLFormElement | null>(null);
const file = ref<File | null>(null);
const message = ref<string>("");
const submitDisabled = ref<boolean>(false);
const uploadInProgress = ref<boolean>(false);
const uploadSuccessful = ref<boolean>(false);
const doneVisible = ref<boolean>(false);

const fileName = computed(() => file.value?.name);
const fileMimeType = computed(() => file.value?.type);

const { getAccessTokenSilently } = useAuth0();

const fileChanged = (event: Event) => {
    console.log(file.value);
    let target = event.target as HTMLInputElement;
    let f = target.files?.item(0);
    if (f) {
        file.value = f as File;
    }
};

const doneClicked = async () => {
    file.value = null;
    message.value = "";
    submitDisabled.value = false;
    doneVisible.value = false;
    form.value?.reset();
}

const submitFile = async () => {
    if (file.value == null) {
        return;
    }
    const reader = new FileReader();
    reader.readAsDataURL(file.value as File);
    reader.onloadend = async () => {
        const result = reader.result as string;
        const encodedFile = result.split(",")[1];
        const fileData = {
            file: encodedFile,
            fileName: fileName.value,
            fileMimeType: fileMimeType.value,
        };

        const accessToken = await getAccessTokenSilently();
        const { data, error } = await postFile(accessToken, fileData);

        uploadInProgress.value = false;
        doneVisible.value = true;

        if (data) {
            message.value = data["message"];
            uploadSuccessful.value = true;
        }

        if (error) {
            message.value = error.message;
            if (error.detail) {
                message.value += ": " + error.detail;
            }
            uploadSuccessful.value = false;
        }
    };
    submitDisabled.value = true;
    uploadInProgress.value = true;
};

</script>
